import { useCallback, useRef } from 'react';
/**
 * Returns given callback with a stable reference, but keeps it updated internally to avoid stale closure.
 * Optional dependency array can be provided to change function render when actually needed.
 * @param callback - function that will be persisted
 * @param deps - optional array of dependencies like in useCallback or useEffect
 */
export default function useCallbackRef(callback, deps = []) {
    const ref = useRef(callback);
    ref.current = callback;
    return useCallback(((...args) => ref.current?.(...args)), deps);
}
